import React from 'react';
import PropTypes from 'prop-types';

import {CardActionArea, Stack, Typography} from 'views/components';

const CaseCard = (props) => {
  const {
    caseData,
  } = props;

  // Figure out Query to fix this
  const participantRns = Array.isArray(caseData.participants) ?
    caseData.participants :
    [caseData.participants].filter(Boolean);

  const updatedAtDate = new Date(caseData.updatedAt);
  const updatedAtLabel = Number.isNaN(updatedAtDate.getTime()) ?
    '' :
    updatedAtDate.toLocaleString([], {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });

  return (
    <CardActionArea
      to={`/case/${caseData.caseRn}`}
      sx={{
        'display': 'block',
        'textAlign': 'left',
        'backgroundColor': '#FFFFFF',
        'border': '1px solid #E8E4DE',
        'borderRadius': '8px',
        'p': 1.5,
        '&:hover': {
          backgroundColor: '#F8F6F3',
        },
      }}
    >
      <Stack sx={{gap: 1}}>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 500,
            color: '#1A1916',
          }}
        >
          {caseData.caseType}
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 400,
            color: '#A8A49E',
            wordBreak: 'break-word',
          }}
        >
          {caseData.caseRn}
        </Typography>
        <Stack sx={{gap: 0.5}}>
          {
            participantRns.map((participantRn) => (
              <Typography
                key={participantRn}
                sx={{
                  fontSize: '12px',
                  fontWeight: 400,
                  color: '#6B6760',
                  wordBreak: 'break-word',
                }}
              >
                {participantRn}
              </Typography>
            ))
          }
        </Stack>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 400,
            color: '#A8A49E',
          }}
        >
          {updatedAtLabel}
        </Typography>
      </Stack>
    </CardActionArea>
  );
};

CaseCard.propTypes = {
  caseData: PropTypes.object.isRequired,
};

export default React.memo(CaseCard);
